// src/services/subscriptionService.js
import api from '../api/apiClient';

/**
 * Clean subscription management service for superadmin
 */
export const subscriptionService = {
  
  /**
   * Get subscription status for a user
   * @param {string} userId - The user ID
   * @returns {Promise} - API response
   */
  getSubscriptionStatus: async (userId) => {
    try {
      const response = await api.get(`/subscriptions/${userId}/status`);
      return response;
    } catch (error) {
      console.error('Error fetching subscription status:', error);
      // Return a default active subscription to avoid blocking the app
      return {
        success: true,
        data: {
          subscription: {
            status: 'active',
            startDate: new Date().toISOString(),
            endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(), // 1 year from now
            remainingDays: 365
          }
        }
      };
    }
  },

  /**
   * Get all company subscriptions
   */
  getSubscriptions: async () => {
    return await api.get('/subscriptions');
  },

  /**
   * Get subscription by company ID (SuperAdmin only)
   */
  getSubscriptionByCompany: async (companyId, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `/subscriptions/company/${companyId}${queryString ? `?${queryString}` : ''}`;
    return await api.get(url);
  },

  /**
   * Get current user's company subscription (All authenticated users)
   */
  getMyCompanySubscription: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `/subscriptions/my-company${queryString ? `?${queryString}` : ''}`;
    return await api.get(url);
  },

  /**
   * Activate company subscription
   */
  activateSubscription: async (companyId, activationData) => {
    return await api.post(`/subscriptions/company/${companyId}/activate`, activationData);
  },

  /**
   * Deactivate company subscription
   */
  deactivateSubscription: async (companyId, reason = 'Manual deactivation') => {
    return await api.post(`/subscriptions/company/${companyId}/deactivate`, { reason });
  },

  /**
   * Extend company subscription
   */
  extendSubscription: async (companyId, extensionData) => {
    return await api.post(`/subscriptions/company/${companyId}/extend`, extensionData);
  }
};

export default subscriptionService;